import AES from 'crypto-js/aes';

const encryptText = (text, key) => AES.encrypt(text, key).toString();

export { encryptText };
